import React, { ReactNode } from "react";
import DateCalendarPicker from "../../../pickers/date-range/DateCalendarPicker";
import EditableLabel from "../editable-label/EditableLabel";
import Styles from "./Date.module.scss";

export default function DateDisplay({
    value, onChange, defaultText,
}: {
    value: Date | undefined | null,
    defaultText?: ReactNode,
    onChange?: (date: Date | undefined) => void;
}) {
    let dateView = (
        <span>
            {value ? value.toLocaleDateString() : defaultText}
        </span>
    );

    if (onChange) {
        const onDone = (done: (() => void)) => (
            <DateCalendarPicker
                allowTime
                onChange={date => {
                    onChange(date);
                    done();
                }}
                value={value}
            />
        );

        dateView = (
            <EditableLabel
                className={Styles.date}
                popoverClassName={Styles.popover}
                placement="auto"
                menu={onDone}
                hideStyle="visibility"
            >
                {dateView}
            </EditableLabel>
        );
    }
    return dateView;
}

DateDisplay.defaultProps = {
    onChange: undefined,
    defaultText: "Unknown",
};
